import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Spinner,
  Image,
  InputGroup,
  FloatingLabel,
  Card,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";


const PaymentForm = ({ paymentType, onBack }) => {
  const [formData, setFormData] = useState({
    name: "",
    payerLastName: "",
    payerFirstName: "",
    payerMiddleName: "",
    groupNum: "",
    docNum: "",
    purpose: paymentType === "education" ? "" : paymentType === "festival" ? "Оплата участия в Международном фестивале «Художественная керамика»" : "Дополнительные образовательные услуги (экскурсия)",
    month: "2 семестр",
    year: "2025",
    summRub: "",
    summCop: "00"
  });

  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  const validateForm = () => {
    const errors = {};
if (paymentType === "education") {
    if (!formData.name.trim()) {
      errors.name = "ФИО обязательно";
    }
  }
    if (!formData.payerLastName.trim()) {
      errors.payerLastName = paymentType === "festival" ? "Фамилия участника обязательна" : "Фамилия плательщика обязательна";
    }
    if (!formData.payerFirstName.trim()) {
      errors.payerFirstName = paymentType === "festival" ? "Имя участника обязательно" : "Имя плательщика обязательно";
    }
    if (!formData.payerMiddleName.trim()) {
      errors.payerMiddleName = paymentType === "festival" ? "Отчество участника обязательно" : "Отчество плательщика обязательно";
    }

    if (!formData.purpose.trim()) {
      errors.purpose = "Назначение платежа обязательно";
    }

    // Поля только для обучения
    if (paymentType === "education") {
      if (!formData.groupNum.trim()) {
        errors.groupNum = "Укажите номер группы или поставьте 0";
      }
      if (!formData.docNum.trim()) {
        errors.docNum = "Укажите номер договора или поставьте 0";
      }
    }

    if (!/^\d+$/.test(formData.summRub) || formData.summRub <= 0) {
      errors.summRub = "Сумма должна быть положительным числом";
    }

    if (
      !/^\d{2}$/.test(formData.summCop) ||
      formData.summCop < 0 ||
      formData.summCop > 99
    ) {
      errors.summCop = "Копейки: от 00 до 99";
    }

    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Опционально: сбрасывать ошибки только по изменённому полю
    if (validationErrors[name]) {
      setValidationErrors({ ...validationErrors, [name]: null });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setLoading(true);
    setError("");

    // Формируем окончательное назначение для фестиваля
    let finalPurpose = formData.purpose;
    let apiPaymentType = paymentType;
    if (paymentType === "festival") {
      // Назначение остаётся как введено (без добавления ФИО)
      // Для API используем тип экскурсии
      apiPaymentType = "excursion";
    }

    try {
      const response = await fetch("https://priem.art-gzhel.ru/api/generate-qr", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, purpose: finalPurpose, paymentType: apiPaymentType}),
      });

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.error || "Неизвестная ошибка сервера");
      }

      setQrData(data.qrCode);
    } catch (err) {
      setError("Ошибка при генерации QR-кода");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Форма и QR */}
      <Container className="mt-3 no-print">
        <div className="mb-3 text-center">
          <div className="d-flex justify-content-end mb-3">
            <Button variant="outline-secondary" size="sm" onClick={onBack}>
              Назад к выбору
            </Button>
          </div>
          <h4 className="text-primary">
            {paymentType === "education" ? "Оплата обучения" : paymentType === "festival" ? "Оплата фестиваля" : "Оплата экскурсии"}
          </h4>
        </div>


        <p className="text-center mb-3">
          {paymentType === "education"
            ? "Формирование QR-кода для оплаты обучения или проживания"
            : paymentType === "festival"
            ? "Формирование QR-кода для оплаты участия в Международном фестивале «Художественная керамика»"
            : "Формирование QR-кода для оплаты экскурсионной программы"}
        </p>

        {paymentType === "education" && (
          <a
            className="text-center d-block mb-3"
            href="https://www.art-gzhel.ru/sveden/paid_edu"
            target="_blank"
            rel="noopener noreferrer"
            style={{ margin: "0 auto", color: "#0d6efd" }}
          >
            Ознакомиться с договором, стоимостью обучения и иными документами
          </a>
        )}

        <Row className="align-items-start justify-content-center">
          {/* Левая колонка: форма */}
          <Col md={5} className="mb-3">
            <Form onSubmit={handleSubmit}>
              {/* ФИО студента/участника */}
              {paymentType === "education" && (
                <FloatingLabel label="ФИО" className="small-label mb-2">
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    isInvalid={!!validationErrors.name}
                    placeholder="Иванов Иван Сергеевич"
                    size="sm"
                    style={{ maxWidth: "400px" }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.name}
                  </Form.Control.Feedback>
                </FloatingLabel>
              )}
              {/* ФИО плательщика/участника */}
              <FloatingLabel label={paymentType === "festival" ? "Фамилия участника" : "Фамилия плательщика"} className="small-label mb-2">
                <Form.Control
                  type="text"
                  name="payerLastName"
                  value={formData.payerLastName}
                  onChange={handleInputChange}
                  isInvalid={!!validationErrors.payerLastName}
                  placeholder="Фамилия"
                  size="sm"
                  style={{ maxWidth: "400px" }}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.payerLastName}
                </Form.Control.Feedback>
              </FloatingLabel>

              <FloatingLabel label={paymentType === "festival" ? "Имя участника" : "Имя плательщика"} className="small-label mb-2">
                <Form.Control
                  type="text"
                  name="payerFirstName"
                  value={formData.payerFirstName}
                  onChange={handleInputChange}
                  isInvalid={!!validationErrors.payerFirstName}
                  placeholder="Имя"
                  size="sm"
                  style={{ maxWidth: "400px" }}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.payerFirstName}
                </Form.Control.Feedback>
              </FloatingLabel>

              <FloatingLabel label={paymentType === "festival" ? "Отчество участника" : "Отчество плательщика"} className="small-label mb-2">
                <Form.Control
                  type="text"
                  name="payerMiddleName"
                  value={formData.payerMiddleName}
                  onChange={handleInputChange}
                  isInvalid={!!validationErrors.payerMiddleName}
                  placeholder="Отчество"
                  size="sm"
                  style={{ maxWidth: "400px" }}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.payerMiddleName}
                </Form.Control.Feedback>
              </FloatingLabel>

              {/* Условные поля: только для обучения */}
              {paymentType === "education" && (
                <>
                  <FloatingLabel label="Номер группы" className="small-label mb-2">
                    <Form.Control
                      type="text"
                      name="groupNum"
                      value={formData.groupNum}
                      onChange={handleInputChange}
                      isInvalid={!!validationErrors.groupNum}
                      placeholder="1 ДПИНП"
                      size="sm"
                      style={{ maxWidth: "400px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.groupNum}
                    </Form.Control.Feedback>
                  </FloatingLabel>

                  <FloatingLabel label="Номер договора" className="small-label mb-2">
                    <Form.Control
                      type="text"
                      name="docNum"
                      value={formData.docNum}
                      onChange={handleInputChange}
                      isInvalid={!!validationErrors.docNum}
                      placeholder="1/Э з/о"
                      size="sm"
                      style={{ maxWidth: "400px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.docNum}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </>
              )}

              {/* Назначение платежа */}
              <FloatingLabel label="Назначение платежа" className="small-label mb-2">
                <Form.Control
                  type="text"
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleInputChange}
                  isInvalid={!!validationErrors.purpose}
                  placeholder="Назначение платежа"
                  size="sm"
                  style={{ maxWidth: "400px" }}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.purpose}
                </Form.Control.Feedback>
              </FloatingLabel>

              {/* Период */}
              {paymentType === "education" && (
                <Form.Group className="mb-2">
                  <Form.Label>Период:</Form.Label>
                  <Row>
                    <Col xs={5} className="mb-2">
                      <Form.Select
                        name="month"
                        value={formData.month}
                        onChange={handleInputChange}
                        size="sm"
                        style={{ maxWidth: "180px" }}
                      >
                        <option value="1 семестр">1 семестр</option>
                        <option value="2 семестр">2 семестр</option>
                        <option value="01">Январь</option>
                        <option value="02">Февраль</option>
                        <option value="03">Март</option>
                        <option value="04">Апрель</option>
                        <option value="05">Май</option>
                        <option value="06">Июнь</option>
                        <option value="07">Июль</option>
                        <option value="08">Август</option>
                        <option value="09">Сентябрь</option>
                        <option value="10">Октябрь</option>
                        <option value="11">Ноябрь</option>
                        <option value="12">Декабрь</option>
                      </Form.Select>
                    </Col>
                    <Col xs={5} className="mb-2">
                      <Form.Select
                        name="year"
                        value={formData.year}
                        onChange={handleInputChange}
                        size="sm"
                        style={{ maxWidth: "150px" }}
                      >
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                        <option value="2027">2027</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Form.Group>
              )}
              {/* Сумма */}
              <InputGroup size="sm" className="mb-2">
                <Form.Control
                  type="text"
                  name="summRub"
                  value={formData.summRub}
                  onChange={handleInputChange}
                  isInvalid={!!validationErrors.summRub}
                  placeholder="Рубли"
                  maxLength={15}
                  style={{ maxWidth: "200px" }}
                />
                <InputGroup.Text>руб.</InputGroup.Text>
                <Form.Control
                  type="text"
                  name="summCop"
                  value={formData.summCop}
                  onChange={handleInputChange}
                  isInvalid={!!validationErrors.summCop}
                  maxLength={2}
                  style={{ maxWidth: "100px" }}
                />
                <InputGroup.Text>коп.</InputGroup.Text>
                <Form.Control.Feedback type="invalid" className="d-block">
                  {validationErrors.summRub || validationErrors.summCop}
                </Form.Control.Feedback>
              </InputGroup>

              {/* Кнопка */}
              <div className="d-flex justify-content-start mt-4">
                <Button variant="primary" type="submit" disabled={loading} size="sm">
                  {loading && <Spinner animation="border" size="sm" className="me-2" />}
                  {loading ? "Генерация..." : "Сформировать QR"}
                </Button>
              </div>

              {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            </Form>

            {/* Подсказки */}
            <ul style={{ color: "red", margin: "30px 0", fontSize: "0.875rem" }}>
              {paymentType === "education" && (
                <li>ФИО плательщика должно совпадать с данными в договоре или документе</li>
              )}
              {paymentType === "education" && (
                <li>
                  Если не знаете номер группы или договора — укажите «0»
                </li>
              )}
              {paymentType === "festival" && (
                <li>
                  Назначение платежа: Оплата участия в Международном фестивале «Художественная керамика»
                </li>
              )}
              {paymentType === "excursion" && (
                <li>
                  Назначение платежа = название экскурсионной программы
                </li>
              )}
            </ul>
          </Col>

          {/* Правая колонка: QR */}
          <Col md={4} className="text-center">
            {qrData && (
              <div className="mt-5">
                <h5>QR-код для оплаты:</h5>
                <Image
                  src={qrData}
                  alt="QR-код"
                  fluid
                  style={{ maxWidth: "320px", border: "2px solid #000" }}
                />
                <div className="mt-3">
                  <Button variant="primary" onClick={() => window.print()} size="sm">
                    Печать квитанции
                  </Button>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Container>

      {/* Печатная квитанция */}
      {qrData && (
        <div className="print-receipt">
          <Container>
            <div
              className="p-4"
              style={{
                maxWidth: "600px",
                margin: "0 auto",
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.5,
              }}
            >
              <h3 className="text-center mb-4">
                Квитанция об оплате{" "}
                {paymentType === "education" ? "обучения" : paymentType === "festival" ? "фестиваля" : "экскурсии"}
              </h3>
               {paymentType === "education" && (
              <p><strong>ФИО:</strong> {formData.name}</p>
               )}
              <p>
                <strong>{paymentType === "festival" ? "Участник" : "Плательщик"}:</strong> {formData.payerLastName} {formData.payerFirstName}{" "}
                {formData.payerMiddleName}
              </p>
              {paymentType === "education" && (
                <>
                  <p><strong>Группа:</strong> {formData.groupNum}</p>
                  <p><strong>Договор:</strong> {formData.docNum}</p>
                </>
              )}
              <p><strong>Назначение:</strong> {formData.purpose}</p>
               {paymentType === "education" && (
              <p><strong>Период:</strong> {formData.month} {formData.year}</p>
               )}
              <p><strong>Сумма:</strong> {formData.summRub} руб. {formData.summCop} коп.</p>
              <div className="mt-4 text-center">
                <p><strong>QR-код:</strong></p>
                <img
                  src={qrData}
                  alt="QR-код"
                  style={{ maxWidth: "380px", border: "1px solid #000" }}
                />
              </div>
              <hr className="my-4" />
              <p className="text-muted text-center">
                Дата формирования: {new Date().toLocaleDateString("ru-RU")}
              </p>
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

// ---- Основной компонент App ----
const App = () => {
  const [selectedType, setSelectedType] = useState(null);

  if (!selectedType) {
    return (
      <Container className="mt-5 text-center no-print">
        <h3 className="mb-4" style={{ color: "#0d6efd" }}>
          Выберите тип оплаты
        </h3>
        <Row className="justify-content-center g-4">
          <Col md={5}>
            <Card
              onClick={() => setSelectedType("education")}
              style={{
                cursor: "pointer",
                border: "2px solid #0d6efd",
                transition: "transform 0.2s",
              }}
              className="shadow-sm"
            >
              <Card.Body>
                <Card.Title>Оплата обучения</Card.Title>
                <Card.Text>Платные образовательные услуги (по договору)</Card.Text>
                <Button variant="primary">Продолжить</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={5}>
            <Card
              onClick={() => setSelectedType("excursion")}
              style={{
                cursor: "pointer",
                border: "2px solid #20c997",
                transition: "transform 0.2s",
              }}
              className="shadow-sm"
            >
              <Card.Body>
                <Card.Title>Оплата экскурсии</Card.Title>
                <Card.Text>Участие в экскурсионной программе</Card.Text>
                <Button variant="success">Продолжить</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={5}>
            <Card
              onClick={() => setSelectedType("festival")}
              style={{
                cursor: "pointer",
                border: "2px solid #ff9800",
                transition: "transform 0.2s",
              }}
              className="shadow-sm"
            >
              <Card.Body>
                <Card.Title>Оплата фестиваля</Card.Title>
                <Card.Text>Участие в Международном фестивале «Художественная керамика»</Card.Text>
                <Button variant="warning">Продолжить</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <style jsx>{`
          .card:hover {
            transform: translateY(-5px);
          }
        `}</style>
      </Container>
    );
  }

  return <PaymentForm paymentType={selectedType} onBack={() => setSelectedType(null)} />;
};

export default App;